import React from 'react'
import { Row, Col, FormGroup, Label, Input } from "reactstrap"
import { FechasPermisosMedicosVacaciones, PlanificacionSolicitudVacaciones, Replanificacion, SolicitudReintegroVacaciones, SolicitudVacaciones } from '../TypesSolicitudVacaciones'
import DatePickerReprogramacion from './DatePickerReprogramacion'
import { function_calcular_dias_ordinarios } from 'functions/DatesFunctions'


type PropsAgregarReprogramacion = {
    justificacionReplanificada: boolean,
    mostrarComponente: boolean,
    diasPendientes: number,
    mensajeErrorPlanificacion: string,
    mensajeErrorListadoReplanificaciones: string,

    listadoReplanificaciones: Replanificacion[],
    feriados: Date[],
    fechasPermisosMedicos: FechasPermisosMedicosVacaciones[],
    fechasLicencia: {
        fechadesde: Date,
        fechahasta: Date
    }[],
    solicitudes: SolicitudVacaciones[],
    solicitudesReintegro: SolicitudReintegroVacaciones[],
    planificaciones: PlanificacionSolicitudVacaciones[],
    solicitudVacacionDeReintegro?: SolicitudVacaciones,
    fechaReintegro?:Date|string,
    fechaDesdeReprogramacion: Date | undefined,
    fechaHastaReprogramacion: Date | undefined,
    onChangeDateDesde: (value: Date | undefined) => void,
    onChangeDateHasta: (value: Date | undefined) => void,
    onClickLimpiarReprogramacion: () => void
    onAddReprogramacion: (fechaDesde: Date, fechaHasta: Date) => void
    permitirMenosDias:boolean
    solicitudReprogramando:"reintegro"|"vacaciones"|"anulacion"
}

export default function AgregarReprogramacion(props: PropsAgregarReprogramacion) {

    const {
        diasPendientes,
        justificacionReplanificada,
        listadoReplanificaciones,
        mostrarComponente,
        mensajeErrorListadoReplanificaciones,
        mensajeErrorPlanificacion,
        fechaDesdeReprogramacion,
        onChangeDateDesde,
        fechaHastaReprogramacion,
        onChangeDateHasta,
        onClickLimpiarReprogramacion,
        onAddReprogramacion
    } = props;

    const diaOrdinarioPlanificado = fechaDesdeReprogramacion !== undefined && fechaHastaReprogramacion !== undefined ? function_calcular_dias_ordinarios(fechaDesdeReprogramacion, fechaHastaReprogramacion) : 0;
    const diasReplanificados = CalcularSumaDiasReplanificaciones(listadoReplanificaciones)
    const excedeDiasPendientes = (diasPendientes - diaOrdinarioPlanificado) < 0;


    function MostrarLabel(valorValidar: number, forValue: string, textoLabel: string) {
        if (valorValidar === 0) {
            const valorHTML = (
                <Label for={forValue}>
                    {textoLabel}
                </Label>
            )
            return valorHTML;
        }
        else {
            return undefined
        }
    }

    function CalcularSumaDiasReplanificaciones(listadoReplanificaciones: Replanificacion[]) {
        if (listadoReplanificaciones.length === 0) {
            return 0;
        }
        else {
            return listadoReplanificaciones.reduce((acum, repl) => acum + repl.diasOrdinarios, 0);

        }
    }




    const ComponenteAgregarReplanificaciones = () => {
       
        const mensajeErrorExcedeDias = "La planificación ingresada excede el número de días disponibles para replanificar. Por favor, escoja otro rango de fechas.";

        const verificaJustificacionReplanificada = justificacionReplanificada;


        if (mostrarComponente) {
            const tieneDiasDisponiblesParaPlanificar = (diasPendientes - CalcularSumaDiasReplanificaciones(listadoReplanificaciones)) > 0;
            const faIconPlus = "fa fa-circle-plus";
            const faIconMinus = "fa fa-circle-minus";

            const classNameIconPlus = listadoReplanificaciones.length === 0 ? `${faIconPlus} marginChange` : `${faIconPlus}`
            const classNameIconMinus = listadoReplanificaciones.length === 0 ? `${faIconMinus} marginChange` : `${faIconMinus}`;
            const htmlComponenteReplanificacion = (
                <>
                    <Row className="rowNuevaFechaPlanificacion">
                        <Col sm={2} md={3}>
                            <FormGroup>
                                {MostrarLabel(listadoReplanificaciones.length, "fechaDesde", "Fecha Desde")}
                                <DatePickerReprogramacion
                                    valueDate={fechaDesdeReprogramacion}
                                    onChangeDate={(e) => onChangeDateDesde(e)}
                                    fechasLicencia={props.fechasLicencia}
                                    fechasPermisosMedicos={props.fechasPermisosMedicos}
                                    feriados={props.feriados}
                                    listadoReplanificaciones={listadoReplanificaciones}
                                    solicitudes={props.solicitudes}
                                    solicitudesReintegro={[]}
                                    solicitudVacacionDeReintegro={props.solicitudVacacionDeReintegro}
                                    planificaciones={props.planificaciones}
                                    tipo='desde'
                                    solicitudReprogramando={props.solicitudReprogramando}
                                    fechaReintegro={props.fechaReintegro}
                                />
                            </FormGroup>
                        </Col>
                        <Col sm={2} md={3}>
                            <FormGroup>

                                {MostrarLabel(listadoReplanificaciones.length, "fechaHasta", "Fecha Hasta")}
                                <DatePickerReprogramacion
                                    valueDate={fechaHastaReprogramacion}
                                    onChangeDate={(e) => onChangeDateHasta(e)}
                                    fechasLicencia={props.fechasLicencia}
                                    fechasPermisosMedicos={props.fechasPermisosMedicos}
                                    feriados={props.feriados}
                                    listadoReplanificaciones={listadoReplanificaciones}
                                    solicitudes={props.solicitudes}
                                    solicitudesReintegro={[]}
                                    solicitudVacacionDeReintegro={props.solicitudVacacionDeReintegro}
                                    tipo='hasta'
                                    valueDesdeDate={fechaDesdeReprogramacion}
                                    planificaciones={props.planificaciones}
                                    solicitudReprogramando={props.solicitudReprogramando}
                                    fechaReintegro={props.fechaReintegro}
                                />
                            </FormGroup>
                        </Col>

                        <>
                            <Col sm={2} md={2}>
                                <FormGroup>

                                    {MostrarLabel(listadoReplanificaciones.length, "diaOrdinarioPlanificado", "Días ordinarios")}
                                    <Input className="text-left" readOnly value={diaOrdinarioPlanificado}> </Input>
                                </FormGroup>
                            </Col>
                            <Col sm={1} className="columnIconMinusReprogramacion">
                                {diaOrdinarioPlanificado > 0 && tieneDiasDisponiblesParaPlanificar && fechaDesdeReprogramacion !== undefined && fechaHastaReprogramacion !== undefined &&
                                    <i
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Limpiar"
                                        onClick={() => onClickLimpiarReprogramacion()}
                                        className={classNameIconMinus}
                                    />
                                }




                            </Col>
                        </>



                    </Row>
                    {mensajeErrorPlanificacion && <small className='small-error'>{mensajeErrorPlanificacion}</small>}
                    {excedeDiasPendientes && <small className='small-error'>{mensajeErrorExcedeDias}</small>}
                    {mensajeErrorListadoReplanificaciones &&
                        <>
                            <br />
                            <small className='small-error'>{mensajeErrorListadoReplanificaciones}</small>
                        </>

                    }

                </>

            )

            return htmlComponenteReplanificacion
        }
        else {
            return undefined
        }

    }

    if (fechaDesdeReprogramacion !== undefined && fechaHastaReprogramacion !== undefined && !excedeDiasPendientes){
        onAddReprogramacion(fechaDesdeReprogramacion,fechaHastaReprogramacion);
    }


        return (
            <React.Fragment>
                {ComponenteAgregarReplanificaciones()}
            </React.Fragment>
        )
}
